export const facebookBotConfig = {
  pageTypes: ['post', ],
  locales: [ ],
  isEmbedded: false,
  isHybrid: false,
  featureId: 'FacebookBot',
  isSlideshow: false,
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/facebook_bot/facebookBotMounterConfig.js